import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AttekintoSablonSzerkeszto from './AttekintoSablonSzerkeszto';

// "2026-10-18 12:30:00" -> "2026. 10. 18. 12:30"
function datumSzoveg(s) {
    const m = /^(\d{4})-(\d\d)-(\d\d) (\d\d):(\d\d)/.exec(s || '');
    return m ? m[1] + '. ' + m[2] + '. ' + m[3] + '. ' + m[4] + ':' + m[5] : '–';
}

// Sablonok (főadmin): a rendezvényekhez rendelhető megrendelés-áttekintő sablonok listája;
// új felvétele, szerkesztése (Twig, Monaco), törlése.
export default function AttekintoSablonokOldal({ callAPI }) {
    const [sablonok, setSablonok] = useState(undefined);
    const [szerkesztes, setSzerkesztes] = useState(undefined);   // {sablonID?}
    const [torlesre, setTorlesre] = useState(undefined);
    const [uzenet, setUzenet] = useState(undefined);

    function betoltes() {
        callAPI('General.listAttekintoSablonok', {}, function (resp) {
            setSablonok(resp.data.sablonok);
        });
    }

    useEffect(() => {
        betoltes();
    }, []);

    function onMentve(sablon) {
        setSzerkesztes(undefined);
        setUzenet('Mentve: ' + sablon.Nev);
        betoltes();
    }

    function onClick_torles_megerosites() {
        const sablon = torlesre;
        setTorlesre(undefined);
        callAPI('General.deleteAttekintoSablon', { sablonID: sablon.Id }, function () {
            setUzenet('Törölve: ' + sablon.Nev);
            betoltes();
        });
    }

    if (sablonok === undefined) {
        return <div className="sablonokOldal" />;
    }

    return (
        <div className="sablonokOldal">
            <div className="sablonokFejlec">
                <div className="sablonokCim">Sablonok</div>
                <Button variant="primary" size="sm" onClick={function () { setSzerkesztes({}); }}>
                    <FontAwesomeIcon icon="fa-plus" /> Új sablon
                </Button>
            </div>
            {uzenet !== undefined ? <div className="rendezvenyUzenet">{uzenet}</div> : undefined}
            <div className="tablaGorgeto">
                <table className="rendezvenyTabla sablonTabla">
                    <thead>
                        <tr>
                            <th>Név</th>
                            <th>Használja</th>
                            <th>Módosítva</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {sablonok.map(function (s) {
                            return (
                                <tr key={s.Id}>
                                    <td className="cim">{s.Nev}</td>
                                    <td>{s.Hasznalat + ' rendezvény'}</td>
                                    <td>{datumSzoveg(s.Modositva)}</td>
                                    <td className="muveletek">
                                        <Button variant="outline-primary" size="sm" onClick={function () { setSzerkesztes({ sablonID: s.Id }); }}>
                                            <FontAwesomeIcon icon="fa-pen" /> Szerkesztés
                                        </Button>
                                        <Button variant="outline-danger" size="sm" disabled={s.Hasznalat > 0}
                                            title={s.Hasznalat > 0 ? 'Rendezvény használja, nem törölhető' : 'Törlés'}
                                            onClick={function () { setTorlesre(s); }}>
                                            <FontAwesomeIcon icon="fa-trash" /> Törlés
                                        </Button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            {szerkesztes !== undefined ?
                <AttekintoSablonSzerkeszto
                    sablonID={szerkesztes.sablonID}
                    callAPI={callAPI}
                    onHide={function () { setSzerkesztes(undefined); }}
                    onMentve={onMentve} />
                : undefined
            }

            <Modal show={torlesre !== undefined} onHide={function () { setTorlesre(undefined); }} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Sablon törlése</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {torlesre !== undefined ? <p>Biztosan törlöd a(z) <b>{torlesre.Nev}</b> sablont? Ez nem vonható vissza.</p> : undefined}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={function () { setTorlesre(undefined); }}>Mégsem</Button>
                    <Button variant="danger" onClick={onClick_torles_megerosites}>Törlés</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
